<script setup lang="ts">
import ProductPage from "@/components/product/ProductPage.vue";

definePageMeta({
  name: "products",
});

const route = useRoute();
const partNumber = computed(() => route.params.partNumber as string);
const routeSlug = computed(() => route.params.slug as string);
</script>

<template>
  <product-page :part-number="partNumber" :slug="routeSlug" />
</template>
